import React from 'react';
import _ from 'lodash';

import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

import { useSearchParams } from 'react-router-dom';
import { CustomSpeedDial } from 'modules';
import { Add } from '@mui/icons-material';
import { modalUtil } from 'iron-forge-react-modules';

import * as AddTemplateModal from './AddTemplateModal/AddTemplateModal';
import * as TemplateGroupDrawer from './TemplateGroupDrawer/TemplateGroupDrawer';
import * as dataService from './dataService';



export const FC: React.FC = () => {
  const queryTuple = dataService.useQuery();
  const [search, setSearch] = useSearchParams();
  const selectedTemplateId = search.get('templateId') ?? '';
  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers(['addTemplateModal']);



  const handleClickRow = React.useCallback(
    (templateId: string) => {
      if (templateId === selectedTemplateId) {
        setSearch(prev => {
          prev.delete('templateId');
          return prev;
        });

      } else {
        setSearch(prev => {
          prev.set('templateId', templateId);
          return prev;
        });
      }
    },
    [selectedTemplateId, setSearch]
  );



  const handleClickSpeedDialOption = React.useCallback(
    (optionId: string) => {
      if (optionId === 'add') {
        setModalIsOpen('addTemplateModal', true);
      }
    },
    [setModalIsOpen]
  );



  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Number of Items</TableCell>
              <TableCell>Created On</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {queryTuple.loading && _.times(10).map(i => (
              <TableRow key={i}>
                <TableCell><Skeleton /></TableCell>
                <TableCell><Skeleton /></TableCell>
                <TableCell><Skeleton /></TableCell>
              </TableRow>
            ))}

            {!queryTuple.loading && queryTuple.data.templates.map(template => (
              <TableRow
                key={template.id}
                onClick={_.partial(handleClickRow, template.id)}
                sx={{ cursor: 'pointer' }}>
                <TableCell>{template.name}</TableCell>
                <TableCell>{template.templateCount}</TableCell>
                <TableCell>{template.createdTimestamp.toFormat('yyyy-MM-dd')}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {selectedTemplateId && (
        <TemplateGroupDrawer.FC
          templateId={selectedTemplateId}
          onClose={() => {
            setSearch(prev => {
              prev.delete('templateId');
              return prev;
            });
          }} />
      )}

      <CustomSpeedDial.FC
        onClickOption={handleClickSpeedDialOption}
        options={[
          {
            id: 'add',
            label: "Add",
            elIcon: <Add />
          }
        ]} />

      {modalType2IsOpen.addTemplateModal && (
        <AddTemplateModal.FC onClose={() => setModalIsOpen('addTemplateModal', false)} />
      )}
    </>
  );
};
